"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiKa = void 0;
const Note_1 = require("../Note");
const NoteType_1 = require("../lib/NoteType");
class MultiKa extends Note_1.Note {
    constructor() {
        super(NoteType_1.NoteType.MultiKa);
    }
}
exports.MultiKa = MultiKa;
